import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { LoginRequest } from '@/models/request/LoginRequest';
import { AUTH_ERRORS, SET_AUTH_ERRORS, SET_AUTH_LOADING_MODE, SET_GOV } from '@/types/authentication.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { RESET_STORE } from '@/types/store.types';
import AuthLoading from '@/components/loading/AuthLoading.vue';
import OfficesMock from '@/globals/officesMock';
import PerformDataCleansingModal from '@/components/modals/PerformDataCleansing.modal.vue';
import {
  INDEX_AND_OFFICES_LIST,
  MUST_PERFORM_DATA_CLEANSING,
  SET_INDEX_AND_OFFICES_LIST,
  SET_UPLOAD_FILE_ENABLE,
} from '@/types/lobby.types';
import { IndexAndOfficesRequest } from '@/models/request/index-and-offices-request';
import {
  SET_PROCESS_COMPARE_REQUESTS_LOADING,
  SYSTEM_CACHE_LIST,
} from '@/types/system.types';

interface Office {
  code: number;
  description: string;
}

@Component({
  components: {
    PerformDataCleansingModal,
  },
})
export default class LoginContainerComponent extends Vue {

  @Inject() public $validator: any;
  @Prop(Boolean)
  public fillUserAgent!: boolean;
  @Prop(String)
  public buttonText!: string;
  @Prop(String)
  public passwordLabelProp!: string;
  @Prop(String)
  public loginHeaderTitle!: string;
  @Prop(String)
  public faIcon!: string;
  @Prop(String)
  public gov!: string;
  @Prop(String)
  public tooltipMessage!: string;
  @Prop(Boolean)
  public showForgot!: boolean;
  @Prop(Boolean)
  public showBackButton!: boolean;
  @Prop(Boolean)
  public hideIdNumberFieldProp!: boolean;
  @Prop(Boolean)
  public hideChangeLoginTypeButton!: boolean;
  @Prop(Boolean)
  public hideIndexNumFieldProp!: boolean;
  @Prop(Boolean)
  public hidePasswordFieldProp!: boolean;
  @Prop(Boolean)
  public showPasswordInstructionProp!: boolean;
  @Prop(Boolean)
  public isButtonIconSpin!: boolean;
  @Prop(Boolean)
  public isButtonLoading!: boolean;
  @Prop(Boolean)
  public skipContextRoot!: boolean;
  @Prop({ default: {} })
  public auth!: LoginRequest;

  @Action(RESET_STORE) public resetStore;

  @Mutation(SET_AUTH_LOADING_MODE, StoreNamespace.AUTHENTICATION) public setAuthLoadingMode;
  @Mutation(SET_AUTH_ERRORS, StoreNamespace.AUTHENTICATION) public setAuthErrors;
  @Mutation(SET_GOV, StoreNamespace.AUTHENTICATION) public setGov;
  @Mutation(SET_INDEX_AND_OFFICES_LIST, StoreNamespace.AUTHENTICATION) public setIndexAndOfficesList;
  @Mutation(SET_UPLOAD_FILE_ENABLE, StoreNamespace.AUTHENTICATION) public setUploadFileEnable;

  @Getter(AUTH_ERRORS, StoreNamespace.AUTHENTICATION) public authErrors!: string[];
  @Getter(INDEX_AND_OFFICES_LIST, StoreNamespace.AUTHENTICATION) public indexAndOfficesList!: IndexAndOfficesRequest[];
  @Getter(MUST_PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public mustPerformDataCleansing!: boolean;

  private passwordLabel: string = 'password';
  private hideIdNumberField: boolean = false;
  private hideIndexNumField: boolean = false;
  private hidePasswordField: boolean = false;
  private showPasswordInstruction: boolean = false;
  private showReCaptcha: boolean = false;
  private serverErrors: string[] = [];
  private officesList: Office[] = [];
  private fa: string = 'far';

  public mounted() {
    document.body.classList.add('login-pages');
    this.setIndexAndOfficesList([]);

    this.showReCaptcha = !!process.env.VUE_APP_RECAPTCHA_SITE_KEY;
    if (this.showReCaptcha) {
      this.setAuthLoadingMode(true);
      this.$recaptchaLoaded()
        .then(() => {
          this.setAuthLoadingMode(false);
        });
    } else {
      this.setAuthLoadingMode(false);
    }

    this.setAuthErrors(null);
    if (this.gov) {
      this.officesList = OfficesMock.offices.sort((a, b) => {
        return a.description === b.description ? 0 : a.description < b.description ? -1 : 1;
      });
    }
    if (this.passwordLabelProp) {
      this.passwordLabel = this.passwordLabelProp;
    }
    this.hideIdNumberField = this.hideIdNumberFieldProp ? this.hideIdNumberFieldProp : false;
    this.hideIndexNumField = this.hideIndexNumFieldProp ? this.hideIndexNumFieldProp : false;
    this.hidePasswordField = this.hidePasswordFieldProp ? this.hidePasswordFieldProp : false;
    this.showPasswordInstruction = this.showPasswordInstructionProp ? this.showPasswordInstructionProp : false;
  }

  public onSubmit(recaptchaV2Response: string) {
    this.setGov(this.gov);
    this.setAuthLoadingMode(true);
    this.setAuthErrors(null);
    this.$emit('submitLogin', recaptchaV2Response);
  }

  public changeLoginType() {
    this.$router.push({ path: this.gov ? '/login?c=gov' : '/login' });
  }

  public onForgetPasswordClick(): void {
    this.$router.push({ path: this.gov ? '/forgot-password?c=gov' : '/forgot-password' });
  }

  public onBackClick(): void {
    this.$router.push({ path: this.gov ? '/password?c=gov' : '/password' });
  }

  public updateIndexNum(office: Office) {
    this.auth.indexNum = office ? office.code : undefined;
  }

  public updateIndexAndOffice(data: IndexAndOfficesRequest) {
    this.auth.indexNum = data && data.indexNum ? data.indexNum : undefined;
    this.auth.officeNum = data && data.officeNum ? data.officeNum : undefined;
  }

  public beforeDestroy(): void {
    document.body.classList.remove('login-pages');
  }

  get loginOneButton(): boolean {
    return this.hideChangeLoginTypeButton;
  }

}
